// src/components/ProtectedRoute.js
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "./Callback.css"; // Reuse Callback styles for consistency

/**
 * ProtectedRoute component that requires authentication
 * Redirects to login page if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const [showTransitionLoader, setShowTransitionLoader] = useState(true);

  // Show loader for minimum duration to prevent flash of blank screen
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // Keep loader visible for brief moment after auth completes
      // This ensures smooth transition from Callback to App
      const timer = setTimeout(() => {
        setShowTransitionLoader(false);
      }, 500); // Increased to 500ms to ensure no gap
      return () => clearTimeout(timer);
    }
  }, [isLoading, isAuthenticated]);

  // Show loading state while checking authentication or during transition
  // Use same styling as Callback component for visual continuity
  if (isLoading || (isAuthenticated && showTransitionLoader)) {
    return (
      <div className="callback-container">
        <div className="callback-content">
          <div className="callback-spinner"></div>
          <h2>Loading Application...</h2>
          <p>Setting up your workspace...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
